import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import ScopedCssBaseline from "@mui/material/ScopedCssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { getBrandingThemeOptions } from "@pangeacyber/react-mui-branding";
import { AuthFlowProvider, AuthFlowView } from "./features/AuthFlow";
import Layout from "./components/Layout";
var App = function () {
    var _a;
    // @ts-ignore
    var token = window.CLIENT_TOKEN;
    // // @ts-ignore
    // const domain = window.PANGEA_DOMAIN;
    // @ts-ignore
    var callback = window.REDIRECT_URI;
    // @ts-ignore
    var flowId = window.FLOW_ID;
    // @ts-ignore
    var branding = window.BRANDING;
    // @ts-ignore
    var isPangea = window.IS_PANGEA || false;
    // @ts-ignore
    var email = window.EMAIL;
    // @ts-ignore
    var clientId = window.CLIENT_ID;
    // @ts-ignore
    var clientSite = window.CLIENT_SITE;
    // @ts-ignore
    var scope = window.SCOPE;
    // @ts-ignore
    var oauth2Nonce = window.OAUTH_NONCE;
    // @ts-ignore
    var oauth2CodeChallenge = window.OAUTH_CODE_CHALLENGE;
    // @ts-ignore
    var oauth2CodeChallengeMethod = window.OAUTH_CODE_CHALLENGE_METHOD;
    // @ts-ignore
    var oauth2State = window.OAUTH_STATE;
    // @ts-ignore
    var oauth2ResponseTypes = window.OAUTH_RESPONSE_TYPES;
    // @ts-ignore
    var oauth2RedirectUrl = window.OAUTH_REDIRECT_URL;
    // @ts-ignore
    var usePathApi = window.USE_PATH_API;
    var brandTheme = useMemo(function () {
        try {
            var themeOptions = getBrandingThemeOptions(branding || {});
            return createTheme(themeOptions);
        }
        catch (_a) {
            // @ts-ignore
            return createTheme();
        }
    }, [branding]);
    var getDomain = function () {
        if (!!usePathApi) {
            return window.location.host;
        }
        // @ts-ignore
        return window.PANGEA_DOMAIN;
    };
    var config = {
        clientToken: token || "",
        domain: getDomain() || "",
        callbackUri: callback || "",
        flowId: flowId || "",
        email: email || "",
        clientId: clientId || "",
        scope: scope || "",
        oauth2Nonce: oauth2Nonce || "",
        oauth2CodeChallenge: oauth2CodeChallenge || "",
        oauth2CodeChallengeMethod: oauth2CodeChallengeMethod || "",
        oauth2State: oauth2State || "",
        oauth2ResponseTypes: oauth2ResponseTypes || "",
        oauth2RedirectUrl: oauth2RedirectUrl || "",
        usePathApi: usePathApi || false,
    };
    var clientOptions = {};
    var viewOptions = {
        brandName: isPangea ? "Pangea" : branding.brand_name || "",
        startHeading: branding.start_heading || "Log in or Sign up",
        startButtonLabel: branding.start_button_label || "Continue with email",
        signupHeading: branding.signup_heading || "Signup",
        signupButtonLabel: branding.signup_button_label || "Continue",
        passwordHeading: branding.password_heading || "Welcome back!",
        passwordButtonLabel: branding.password_button_label || "Sign in",
        socialHeading: branding.social_heading || "Other ways",
        showSocialIcons: (_a = branding.authn_show_social_icons) !== null && _a !== void 0 ? _a : true,
        otpButtonLabel: branding.otp_button_label || "Submit",
        captchaHeading: branding.captcha_heading || "Prove you're human",
        eulaHeading: branding.eula_heading || "Accept License Agreement",
        privacyHeading: branding.privacy_heading || "Accept Privacy Policy",
        submitLabel: branding.authn_submit_label || "Submit",
        cancelLabel: branding.authn_cancel_label || "Start over",
        compactSignup: isPangea ? true : false,
        rememberUser: isPangea ? true : false,
        clientSiteUrl: clientSite,
    };
    return (_jsx(ThemeProvider, { theme: brandTheme, children: _jsx(ScopedCssBaseline, { style: {
                position: "absolute",
                width: "100%",
                height: "100%",
            }, children: _jsx(AuthFlowProvider, { config: config, options: clientOptions, children: _jsx(Layout, { branding: branding, isPangea: isPangea, children: _jsx(AuthFlowView, { options: viewOptions, isPangea: isPangea }) }) }) }) }));
};
export default App;
